<template>
	<v-flex
		xs12
		sm8
		md4
	>
		<v-card class="elevation-12">
			<v-toolbar
				dark
				flat
				color="primary"
			>
				<v-toolbar-title>Reset Password</v-toolbar-title>
			</v-toolbar>
			<v-progress-linear
				v-if="loading"
				class="ma-0"
				indeterminate
			/>
			<v-form
				ref="login"
				v-model="valid"
				@submit.prevent="submit"
			>
				<v-card-text class="text-xs-center">
					<v-text-field
						v-model="password"
						:rules="[...validate.require, validate.lengthMin8]"
						prepend-icon="lock"
						name="password"
						label="New Password"
						type="password"
					/>
					<v-text-field
						v-model="passwordConfirm"
						:rules="[validateSamePass(passwordConfirm, password)]"
						prepend-icon="lock"
						name="password-confirm"
						label="Confirm Password"
						type="password"
					/>
				</v-card-text>
				<v-card-actions>
					<v-spacer/>
					<v-btn
						:disabled="!valid"
						color="primary"
						type="submit"
						class="ma-2"
					>
						Reset
					</v-btn>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-flex>
</template>

<script>
import Validation from '@/mixins/Validation';
import { Reset } from '@/models/Login';

export default {
	mixins: [Validation],
	data() {
		return {
			valid: true,
			password: '',
			passwordConfirm: '',
			token: '',
			loading: false,
		};
	},
	created() {
		if (this.$route.query.token) {
			this.token = this.$route.query.token;
			return;
		}
		this.$notify('error', 'You must request a password reset first.');
		this.$router.replace({ name: 'Login', query: { forgot: true } });
	},
	methods: {
		submit() {
			this.loading = true;
			const reset = new Reset({ token: this.token, newPassword: this.password });
			reset.save().then(() => {
				this.$notify('success', 'Password has been successfully reset.');
				this.$router.replace({ name: 'Login' });
			}).catch((error) => {
				// If the token is used.
				if (error.response.response.status === 400) {
					this.$notify('error', 'This reset link is no longer valid, please request a new one.');
					this.$router.replace({ name: 'Login', query: { forgot: true } });
					return;
				}
				this.$notify('error', error.response.response.data.message);
			}).finally(() => {
				this.loading = false;
			});
		},
	},
};
</script>

<style>

</style>
